import { lazy } from "react";

const GuestSpeakers         = lazy(() => import("./pages/GuestSpeakers"));

export const routes: any = [
    {
        path: "guest-speakers",
        permission: "guest-speakers:read",
        element: <GuestSpeakers />,
    },
];
